module.exports = __webpack_public_path__ + "img/aneushape.2b2478bb.png";